/**
 * Origem do contato para leads captados pelo chat de pós-graduação.
 *
 * Os botões da página de informações ("Tenho uma Dúvida", "Ver Programa
 * do Completo", "Falar com Consultor") passaram a abrir o chat no lugar
 * dos formulários modais. O botão clicado é enviado no `detail.source`
 * do evento `openPostgraduateChat` e vira o custom field `origem_contato`
 * do negócio no Agendor — exatamente como os formulários faziam.
 * Aberturas pelo launcher flutuante ou pelo auto-open de 10s continuam
 * como `'Chat'`.
 */

import {
  AGENDOR_CONTACT_ORIGIN,
  type AgendorContactOrigin,
} from '@/helpers/postgraduate-agendor-funnel'

/** Valor do custom field `origem_contato` quando ninguém clicou num botão. */
export const CHAT_LAUNCHER_CONTACT_ORIGIN = 'Chat'

const BUTTON_CONTACT_ORIGINS: ReadonlySet<string> = new Set<string>(
  Object.values(AGENDOR_CONTACT_ORIGIN)
)

/** `true` quando `source` é um valor de `AGENDOR_CONTACT_ORIGIN` (opção real do CRM). */
export function isButtonContactOrigin(
  source: unknown
): source is AgendorContactOrigin {
  return typeof source === 'string' && BUTTON_CONTACT_ORIGINS.has(source)
}

/**
 * Traduz o `source` de abertura do chat no valor a enviar ao Agendor.
 * Só valores conhecidos do CRM passam; qualquer outra coisa vira `'Chat'`.
 */
export function resolveChatContactOrigin(
  source: string | null | undefined
): string {
  return isButtonContactOrigin(source) ? source : CHAT_LAUNCHER_CONTACT_ORIGIN
}

/** Só "Ver programa completo" dispara o envio do programa por e-mail (RN08/RN09). */
export function shouldSendProgramMaterial(
  origin: string | null | undefined
): boolean {
  return origin === AGENDOR_CONTACT_ORIGIN.VER_PROGRAMA_COMPLETO
}
